<template>
  <el-drawer
    :visible.sync="visible"
    :title="currentTitle"
    direction="rtl"
    size="30%"
    :before-close="handleClose"
    :destroy-on-close="true"
    custom-class="unqualified-drawer-dialog"
  >
    <Main
      v-if="visible"
      ref="mainRef"
      :inspection-code="inspectionCode"
      @confirm="handleConfirm"
      @close="close"
      @update:status-step="handleStatusStepChange"
    />
  </el-drawer>
</template>

<script>
import Main from './main.vue'

export default {
  name: 'UnqualifiedDrawer',
  components: { Main },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    inspectionCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentStatusStep: 'A'
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    currentTitle() {
      return this.currentStatusStep === 'A' 
        ? this.$l('dialog_title_handle_method') || '处理方式' 
        : this.$l('dialog_title_select_reason') || '选择申请理由'
    }
  },
  methods: {
    close() {
      this.visible = false
      this.$emit('close')
    },
    handleClose() {
      // 如果在 Step B，先返回 Step A
      if (this.currentStatusStep === 'B') {
        this.$refs.mainRef?.backToStepA()
        return
      }
      
      // 在 Step A 时才提示关闭确认
      this.$confirm(
        this.$l('tips_close_lose_data') || '关闭后填写的数据将会丢失，确认关闭吗？', 
        this.$l('tips_operation') || '操作提示', 
        {
          confirmButtonText: this.$l('btn_close') || '关闭',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.visible = false
          this.$emit('close')
        })
        .catch(() => {})
    },
    handleConfirm(data) {
      this.$emit('confirm', data)
      this.visible = false
    },
    handleStatusStepChange(step) {
      this.currentStatusStep = step
    }
  }
}
</script>

<style lang="scss">
.unqualified-drawer-dialog {
  :deep(.el-drawer__header) {
    padding: 20px;
    margin-bottom: 0;
    border-bottom: 1px solid #e8e8e8;
    > span {
      font-size: 16px;
      font-weight: 600;
    }
  }
  :deep(.el-drawer__body) {
    padding: 0;
    overflow-y: auto;
  }
}
</style>
